import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    displayName: {
        // field
        label: "Название",
        inputProps: { name: "displayName" },
        required: true,
        validators: [requiredField],
    },
    options: {
        config: {
            isMileagePaid: {
                label: "Пробег оплачен",
                inputProps: { name: "isMileagePaid" },
                checkbox: true,
            },
        },
    },
    id: {},
    catalogId: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
